import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionAnswerCreateInput } from '../generated/globalTypes';
import { createQuestionAnswerMutation, createQuestionAnswerMutationVariables } from '../generated/createQuestionAnswerMutation';
import { questionAnswerFieldsFragment } from '../models/QuestionAnswer';

/**
 * Get a callback to create a QuestionAnswer in the store.
 */
export function useCreateQuestionAnswerCallback(): [(model: QuestionAnswerCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionAnswerMutation, createQuestionAnswerMutationVariables>(
        gql`
            mutation createQuestionAnswerMutation ($model: QuestionAnswerCreateInput!) {
                createQuestionAnswer(model: $model) {
                    ...questionAnswerFields
                }
            }

            ${questionAnswerFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionAnswerCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
